import { render, staticRenderFns } from "./StudentDashboardHeadline.vue?vue&type=template&id=421458d8&scoped=true"
import script from "./StudentDashboardHeadline.vue?vue&type=script&lang=ts"
export * from "./StudentDashboardHeadline.vue?vue&type=script&lang=ts"
import style0 from "./StudentDashboardHeadline.vue?vue&type=style&index=0&id=421458d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421458d8",
  null
  
)

export default component.exports